// extracted by mini-css-extract-plugin
export default {"wrapper":"RequiredLogin_wrapper__tJxM9"};